var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#212843"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.538 18.8882C23.0239 21.1868 20.5182 23.4779 18.0042 25.7765L13.6087 21.7577L15.1821 20.3192L18.0042 22.8994L22.3996 18.8806L18.0042 14.8619C16.0146 16.681 14.0333 18.5001 12.0437 20.3115C10.0291 18.4848 8.01457 16.6429 6 14.801L7.57336 13.3624L12.0437 17.4497L18.0042 12L25.538 18.8882ZM27.103 17.4497L30 14.801L28.4266 13.3624L25.5297 16.0112L27.103 17.4497Z",
    fill: "url(#paint0_linear_438_586)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_438_586",
    x1: 23.5276,
    y1: 12.6939,
    x2: 13.0807,
    y2: 20.6945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E0274E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF0C7C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgLogo);
export default __webpack_public_path__ + "static/media/tg-logo.bf9ce5b0e1ce0a0000cd9b8974f258e7.svg";
export { ForwardRef as ReactComponent };